import React from "react";
import { Grid } from "@mui/material";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";

import styles from "../../../../assets/styles/componentStyles/templateLibraryStyles/modifyWhatsAppTemplate/whatsAppTemplateForm.module.scss";

interface VariableDisclaimerProps {
    text: string;
    className?: string;
}

const VariableDisclaimer = ({ text, className }: VariableDisclaimerProps) => (
    <Grid
        container
        flexWrap="nowrap"
        alignItems="center"
        gap={1}
        className={className ? `${styles.addSampleVariableTextGrid} ${className}` : styles.addSampleVariableTextGrid}
    >
        <Grid item>
            <ReportProblemOutlinedIcon className={styles.variableDisclaimerIcon} />
        </Grid>

        <Grid item>
            <span className={styles.variableDisclaimerText}>
                {text}
            </span>
        </Grid>
    </Grid>
);

export default VariableDisclaimer;